import { render, staticRenderFns } from "./SectionTagList.vue?vue&type=template&id=1a54c0b0&scoped=true&"
import script from "./SectionTagList.vue?vue&type=script&lang=ts&"
export * from "./SectionTagList.vue?vue&type=script&lang=ts&"
import style0 from "./SectionTagList.vue?vue&type=style&index=0&id=1a54c0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54c0b0",
  null
  
)

export default component.exports